import StoreHero from './storeHero'

export default StoreHero